/**
 * Driver Authentication Configuration
 *
 * Add/remove drivers here. Each driver needs:
 * - username: login name (lowercase, no spaces)
 * - password: their password
 * - name: display name
 * - active: true/false to enable/disable
 *
 * To add a new driver:
 *   1. Add new object to the DRIVERS array
 *   2. Deploy the changes
 *
 * To disable a driver:
 *   1. Set active: false (keeps history)
 *   2. Or remove the entire entry
 */

export const DRIVERS = [
  {
    username: 'info@norcalmobileoilchange.com',
    password: 'Test@123',
    name: 'NorCal',
    role: 'admin',
    active: true
  },
  {
    username: 'denis',
    password: 'norcal2024',
    name: 'Denis',
    role: 'admin',
    active: true
  }
  // Add more drivers here:
  // {
  //   username: 'newdriver',
  //   password: 'securepass',
  //   name: 'New Driver Name',
  //   active: true
  // }
];

/**
 * Authenticate a driver
 * @param {string} username
 * @param {string} password
 * @returns {object|null} Driver object if valid, null if invalid
 */
export const authenticateDriver = (username, password) => {
  const driver = DRIVERS.find(
    d => d.username.toLowerCase() === username.toLowerCase() &&
         d.password === password &&
         d.active
  );
  return driver || null;
};
